import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

internals.gettAllTripCount = function(cityId) {
  return http
    .get(`/trip/primary-trip/dashboard/all-Trip-countsByStatus?cityIds=${cityId}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('dashBoardService.gettAllTripCount-error:\n', error)
      throw error
    })
}

internals.allDashboardDetails = function(cityId) {
    return http
      .get(`/dataInDasboard/listing/count?cityId=${cityId}`)
      .then(result => {
        return result
      })
      .catch(error => {
        console.error('dashBoardService.gettAllTripCount-error:\n', error)
        throw error
      })
  }

export default internals



// WEBPACK FOOTER //
// ./src/services/dashboard.service.js